module.exports = "<h1 id=\"16-珍藏条系数--きららジャンプゲージ倍率変化\">16. 珍藏条系数 / きららジャンプゲージ倍率変化</h1>\n<p><strong><code>KiraraJumpGaugeCoef</code>。</strong>未出现过</p>\n";